import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { initialAuthState } from './auth.state';

export const authReducer = createReducer(
    initialAuthState,
    on(AuthActions.login, state => ({
        ...state, loginLoading: true, loginError: null
    })),
    on(AuthActions.loginSuccess, AuthActions.restoreSession, (state, { token, user }) => ({
        ...state,
        token,
        user,
        isAuthenticated: true,
        loginLoading: false,
        loginError: null,
    })),
    on(AuthActions.loginFailure, (state, { error }) => ({
        ...state, loginLoading: false, loginError: error
    })),
    on(AuthActions.logout, AuthActions.sessionExpired, () => ({
        ...initialAuthState
    })),
    on(AuthActions.loadPermissionsSuccess, (state, { permissions }) => ({
        ...state, permissions
    })),
);
